import { createFeatureSelector } from '@ngrx/store';
import { SubmittalsState } from '@submittals/reducers';

export const selectSubmittalsModule = createFeatureSelector<SubmittalsState>('submittals');
